import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import InDevel from '../components/InDevel';


const Other = () => {
    const { t } = useTranslation();

    return (
        <div>
            <Typography variant='h5'>
                {t('other:title')}
            </Typography>
            <InDevel />
        </div>
    );
};

export default Other;